import { Row, Col, Form, Table } from "react-bootstrap";
import { useImperativeHandle, forwardRef, useState, useEffect } from "react";
import { isAllowCustomSpecialCharacters, isAlphanumericAllSpecialCharacters } from "../../functions/validations";
import { validateWPSForm, validateWPSTempForm } from "./WPS_ValidationConfig";
import { Backing, Flux_recrush, TypeData, WeldLayer, } from "../utility/common/TransactionComponents/TransactionEntity";
import { Addition_deletion_changes, Addition_deletion_filler, Addition_deletion_flux, Alloy_element, Alloy_flux, company_name, Flux_type } from "./WPSObjects/WPSGroove_entity";
import { maxlength_WPS } from "./WPSObjects/maxlength_WPS";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import { BiSelectMultiple } from "react-icons/bi";
import { handleHeaderDetailAdd, handleStatusChange } from "./WPSObjects/WPSDataService";
import { RenderIf } from "../../functions/welding-functions";
import SingleValuePopUp from "../utility/ui/modals/SingleValuePopUp";
import { getAllOnlyProject } from "../../Services/project-services";
import { useLocation } from "react-router-dom";
import { getPNOActive } from "../../Services/pcategory-service";
import { getActiveAno } from "../../Services/ano-services";
import { getActiveProcess } from "../../Services/weldingprocess-services";
import { getActiveSfa } from "../../Services/sfa-service";
import { getActiveFno } from "../../Services/fno-services";
import { WPS_Thickness_Groove } from "./WPSObjects/WPS_thickness_groove";
import { WPS_Thickness_overlay } from "./WPSObjects/WPS_thickness_overlay";
import { DeleteWPS, getdetailsById } from "../../Services/wps_details-service";
import Tooltip from "../utility/common/helpers/Tooltip";
import Error from "../../icons/ErrorIcon.svg";
import { todayDate, maxDate } from "../utility/common/helpers/TodayDate";
import { SingleInput, General_Single_Input_select } from "../utility/forms/inputs/InputsTransaction";
import { getActiveItemForProject } from "../../Services/item-services";
import { DateInput } from "../utility/common/helpers/DateComponent";
import { errorstyle, greenstyle, normalstyle } from "../../functions/welding-functions";
import {
  CSS_CLASSES,
  WPS_TYPES,
  DEFAULT_ERROR_ITEM,
  Action,
} from "../utility/common/constants/CommonConstants";
import {
  emptyError,
  AddRowsDetailsoBj,
  initializeErrorState,
  handleGeneralSubmit,
  handleGeneralSubmitTemp,
  handleHeaderchange,
  handleDetailChange,
} from "./WPSObjects/WPSCommonUtils";
import { DotLoader } from "react-spinners";
import FluxDetailsCheckboxes from "./WPSObjects/FluxDetailsCheckboxes";
import { WPSFillerMetalRow } from "./WPSObjects/FillerMetalRow";

const General = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      setdetailObj,
      WPStype,
      setIsEditedPage1,
      isReadonly,
      action,
      setAction,
      setReadOnly,
    },
    ref
  ) => {
    const location = useLocation();
    const [ProjectDetails, setProjectDetails] = useState([]);
    const [AnoActive, setAnoActive] = useState([]);
    const [FnoActive, setFnoActive] = useState([]);
    const [SfaActive, setSfaActive] = useState([]);
    const [ProcessActive, setProcessActive] = useState([]);
    const [PNoActive, setPNoActive] = useState([]);
    const [ItemActive, setItemActive] = useState([]);
    const [IsEdited, setIsEdited] = useState(false);
    const [loading, setLoading] = useState(false);

    const [consumError, setConsumError] = useState([DEFAULT_ERROR_ITEM]);
    const [fluxError, setFluxError] = useState([DEFAULT_ERROR_ITEM]);
    const [supfilterError, setSupFilterError] = useState([DEFAULT_ERROR_ITEM]);
    const [classError, setClassError] = useState([]);
    const [chemicalAnaError, setChemicalAnaError] = useState([]);
    const [FMMinError, setFMMinError] = useState([]);
    const [FMMaxError, setFMMaxError] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [popUp, setPopUp] = useState({
      name: "",
      type: "",
      key: "",
      value: "",
    });

    const showPopUp = (name, type, key, value) => {
      setPopUp({ name, type, key, value });
      setShowForm(true);
    };

    const setPopUpData = (data) => {
      if (data.name === "ItemActive") {
        setheaderObj((prev) => ({
          ...prev,
          WPSH_FM_FluxItemCode: data.result.wld_itemcode,
        }));
        setError((prevState) => ({
          ...prevState,
          WPSH_FM_FluxItemCode: {},
        }));
      }
    };

    const isoverlay = WPStype !== WPS_TYPES.GROOVE;
    const isgroove = WPStype === WPS_TYPES.GROOVE;

    const grooveclass =
      WPStype === WPS_TYPES.GROOVE
        ? CSS_CLASSES.ROW_MARGIN
        : CSS_CLASSES.D_NONE;
    const overclass =
      WPStype !== WPS_TYPES.GROOVE
        ? CSS_CLASSES.ROW_MARGIN
        : CSS_CLASSES.D_NONE;

    const message = (errobj) => {
      let msg = "",
        allmsg = "";
      errobj.map((i) => {
        if (i.id !== "" && i.id !== "all") msg = i.msg + ", ";
        if (i.id === "all") allmsg = i.msg;
      });
      msg = msg + allmsg;
      return msg;
    };

    const [error, setError] = useState(initializeErrorState("page1"));

    const handleChange = (e) => {
      handleHeaderchange(
        e,
        { setheaderObj, setError },
        { action, setIsEdited, setEditedPage1: setIsEditedPage1, setEditedPage2: null, setEditedPage3: null },
        error
      );
    }
    const handleSelectChange = (e) =>
      handleHeaderchange(
        e,
        { setheaderObj, setError },
        { action, setIsEdited, setEditedPage1: setIsEditedPage1, setEditedPage2: null, setEditedPage3: null },
        error
      )

    const handleChangedetailsarray = (e, i) => {
      let clearError = !String(error[e.target.name].message) == "Special"
      handleDetailChange(
        e,
        i,
        { detailObj, setdetailObj },
        { setError },
        { action, setIsEdited, setIsEditedPage2: setIsEditedPage1 },
        { clearError }
      );
    }
    const validate = async () => {
      const validationResult = await validateWPSForm({
        headerObj,
        detailObj,
        WPStype,
        currentErrors: error,
        pageType: "page1",
        action,
        setConsumError,
        setFluxError,
        setSupFilterError,
        todayDate,
      });

      setError(validationResult.errors);
      console.log("in VAlidate",validationResult.isError)
      return {isError:validationResult.isError};
    };

    const validateTemp = async () => {
      let temperror = emptyError(error, setError, false);

      const validationResult = await validateWPSTempForm({
        headerObj,
        detailObj,
        currentErrors: error,
        action,
        todayDate,
      });

      // Handle specific temp validation logic
      if (
        detailObj[0].WPSD_Process !== "" &&
        detailObj[0].WPSD_FM_FNo !== "" &&
        detailObj[0].WPSD_Type !== ""
      ) {
        detailObj[0].error = false;
      }

      setError((prevState) => ({
        ...prevState,
        ...validationResult.errors,
      }));

      return { isError: validationResult.isError, temperror };
    };
    const handleAdd = async (approvalstatus) => {
      handleStatusChange(headerObj, location, action);


      // Prepare detail data with additional processing
      const filteredDetails = detailObj.filter(
        (item) => item.WPSD_Process !== "NA" && item.WPSD_Process !== ""
      );

      let WPSH_WPS_Process = "";
      let WPSH_WPS_Type = "";
      let WPSH_WPS_WeldLayer = "";


      for (const item of filteredDetails) {
        item.WPSH_Project_No = headerObj.WPSH_Project_No;
        item.WPSH_WPS_No = headerObj.WPSH_WPS_No;
        item.WPSH_WPS_Revi_No = headerObj.WPSH_WPS_Revi_No;
        item.PK = headerObj.WPSH_Project_No + "#" + headerObj.WPSH_WPS_No;
        WPSH_WPS_Process += item.WPSD_Process + ",";
        WPSH_WPS_Type += item.WPSD_Type + ",";
        WPSH_WPS_WeldLayer += item.WPSH_WeldLayer;
        item.WPSH_WPS_Process = headerObj.WPSH_WPS_Process;
        item.WPSH_WPS_Type = headerObj.WPSH_WPS_Type;
        item.SK = item.WPSD_Process + "#" + item.WPSD_Type;
        item.WPSD_ProcessCategory = item.WPSD_Process + "#" + item.WPSD_Type;

        headerObj.WPSH_WPS_Process = WPSH_WPS_Process;
        headerObj.WPSH_WPS_Type = WPSH_WPS_Type;
        headerObj.WPSH_WPS_WeldLayer = WPSH_WPS_WeldLayer;
        let weldingProcessCategory = ProcessActive.filter(
          (element) => element.wld_code === item.WPSD_Process
        );
        item.WPSD_WP_WeldingProcess = weldingProcessCategory[0]?.wld_p_category;
      }

      // Handle old process deletion
      try {
        let oldprocess = await getdetailsById(
          headerObj.WPSH_Project_No,
          headerObj.WPSH_WPS_No
        );

        for (const item of oldprocess) {
          const NotFoundprocess = filteredDetails.filter(
            (i) =>
              i.PK.toString() === item.PK.toString() &&
              i.SK.toString() === item.SK.toString()
          );
          if (NotFoundprocess && NotFoundprocess.length <= 0) {
            await DeleteWPS(item.PK, item.SK).catch((e) => {
              console.error("Error deleting old process:", e);
            });
          }
        }
      } catch (error) {
        console.error("Error handling old processes:", error);
      }

      // Use common WPS data service
      const result = await handleHeaderDetailAdd(
        headerObj,
        filteredDetails,
        location
      );

      if (result === true) {
        setAction(Action.ActionEdit);
        AddRowsDetailsoBj(filteredDetails, setdetailObj);
      }


      return result;
    };

    const fetchProject = async () => {
      const result = await getAllOnlyProject();
      setProjectDetails(result);
    };

    const fetchProcess = async () => {
      const result = await getActiveProcess();
      const process = [{ wld_code: "NA" }, ...result];

      setProcessActive(process);
    };

    const fetchSfa = async () => {
      const result = await getActiveSfa();
      setSfaActive(result);
    };
    const fetchPNo = async () => {
      const result = await getPNOActive();
      setPNoActive(result);
    };

    const fetchItem = async () => {
      const result = await getActiveItemForProject(headerObj.WPSH_Project_No);
      // Handle case where API returns error object instead of array
      if (Array.isArray(result)) {
        const FinalItem = [{ wld_itemcode: "NA" }, ...result];
        const filterResult = FinalItem.filter((e) => e.wld_itemcode);
        setItemActive(filterResult);
      } else {
        // Set default value if API fails
        setItemActive([{ wld_itemcode: "NA" }]);
      }
    };

    const fetchfno = async () => {
      const result = await getActiveFno();
      const uniqueFnoData = Array.from(
        new Map(result.map((item) => [item.wld_code, item])).values()
      );
      setFnoActive(uniqueFnoData);
    };

    const fetchAno = async () => {
      const result = await getActiveAno();
      setAnoActive(result);
    };

    useEffect(() => {
      fetchProcess();
      fetchSfa();
      fetchfno();
      fetchAno();
      if (action !== Action.ActionEdit) fetchProject();
      fetchPNo();
    }, []);

    useEffect(() => {
      fetchItem();
    }, [headerObj.WPSH_Project_No]);

    const handleSubmit = () =>
      handleGeneralSubmit(validate, handleAdd, setLoading, setIsEditedPage1, headerObj.WPSH_Status);

    const handleSubmitTemp = () =>
      handleGeneralSubmitTemp(
        IsEdited,
        validateTemp,
        handleAdd,
        setLoading,
        setIsEdited,
        setIsEditedPage1, headerObj.WPSH_Status
      );

    useImperativeHandle(ref, () => ({
      funcOnNext: async () => {
        let res = false;
        res = await handleSubmit();
        return res;
      },

      funcOnNextTemp: async () => {
        let res = false;
        res = await handleSubmitTemp();
        return res;
      },
    }));

    return (
      <>
        <Row className="font">
          {loading && (
            <div className="loader-overlay">
              <DotLoader size={80} className="pageloader" />
            </div>
          )}
          <Row style={{ padding: "20px 60px" }} className="WPS-Page-row-padding">
            <Row className="mb-2" style={{ position: "relative" }}>
              <Col md={3} style={{ width: "20%" }}>
                <Form.Group className="pro-input-select">
                  <div className="search-select">
                    <SearchSelect
                      id="WPSH_Project_No"
                      name="WPSH_Project_No"
                      className={error.WPSH_Project_No.status ? "err-input" : ""}
                      stylegreen={
                        error.WPSH_Project_No.status ? errorstyle : normalstyle
                      }
                      data={ProjectDetails}
                      valueField={"wld_ProjectNumber"}
                      disabled={action === Action.ActionEdit}
                      value={headerObj.WPSH_Project_No}
                      labelField={"wld_ProjectNumber"}
                      placeholder=""
                      onChange={(ProjectList) => {
                        setIsEditedPage1(true);
                        setIsEdited(true);
                        setheaderObj((prev) => ({
                          ...prev,
                          WPSH_Project_No: ProjectList.value,
                          WPSH_FM_FluxItemCode: "",
                        }));
                        setError((prevState) => ({
                          ...prevState,
                          WPSH_Project_No: {},
                          WPSH_FM_FluxItemCode: {},
                        }));
                        //When project changes item related data is set to blank
                        for (let i in detailObj) {
                          detailObj[i].WPSH_Project_No = ProjectList.value;
                          detailObj[i].WPSD_WP_WeldConsumable[0] = ""
                          detailObj[i].WPSD_WP_WeldConsumable[1] = ""
                          detailObj[i].WPSD_WP_WeldConsumable[2] = ""
                          detailObj[i].welddesc[0] = ""
                           detailObj[i].welddesc[1] = ""
                            detailObj[i].welddesc[2] = ""
                          detailObj[i].weldweight[0] = ""
                           detailObj[i].weldweight[1] = ""
                            detailObj[i].weldweight[2] = ""
                      
                        }
                        if (action === Action.ActionCopy) {
                          setReadOnly(false);
                        }
                      }}
                    ></SearchSelect>
                  </div>
                  <Form.Label>Project Number</Form.Label>
                  <div className="required-text-select">
                    {error.WPSH_Project_No.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_Project_No.message}
                      </Form.Text>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <SingleInput
                divstyle="T-input w-100"
                width="201px"
                id="WPSH_WPS_No"
                name="WPSH_WPS_No"
                label="WPS No."
                disabled={action === Action.ActionEdit}
                maxLength={maxlength_WPS.WPSH_WPS_No}
                status={error.WPSH_WPS_No.status}
                message={error.WPSH_WPS_No.message}
                value={headerObj.WPSH_WPS_No}
                setError={setError}
                error={error}
                onChange={(e) => {
                  handleChange(e);
                  for (let i in detailObj) {
                    detailObj[i].WPSH_WPS_No = e.target.value;
                  }
                  if (action === Action.ActionCopy) {
                    setReadOnly(false);
                  }
                }}
                allowlistfunction={isAllowCustomSpecialCharacters}
                allowcharacters="-"
                customMessage="Special Characters # & % + $ ' < > = ; not allowed"
              />
              <SingleInput
                divstyle="T-input w-100"
                id="WPSH_WPS_Revi_No"
                name="WPSH_WPS_Revi_No"
                disabled={isReadonly}
                label="WPS Rev.No."
                maxLength={maxlength_WPS.WPSH_WPS_Revi_No}
                status={error.WPSH_WPS_Revi_No.status}
                message={error.WPSH_WPS_Revi_No.message}
                value={headerObj.WPSH_WPS_Revi_No}
                setError={setError}
                error={error}
                onChange={(e) => {
                  handleChange(e);
                  for (let i in detailObj) {
                    detailObj[i].WPSH_WPS_Revi_No = e.target.value;
                  }
                }}
              />
              <Col md={3} style={{ width: "255px" }}>
                <DateInput
                  divClass="T-input w-100"
                  label="WPS Date"
                  className="groove_datecolor"
                  name="WPSH_WPS_Date"
                  todayDate={todayDate}
                  maxDate={maxDate}
                  disabled={isReadonly}
                  obj={headerObj}
                  setobj={setheaderObj}
                  setError={setError}
                  status={error.WPSH_WPS_Date.status}
                  message={error.WPSH_WPS_Date.message}
                />
              </Col>
              <SingleInput
                divstyle="T-input w-100"
                md={3}
                style={{ position: "relative", left: "8px" }}
                id="WPS_QualifiedTo"
                name="WPS_QualifiedTo"
                label="Qualified To"
                disabled={isReadonly}
                maxLength={maxlength_WPS.WPS_QualifiedTo}
                status={error.WPS_QualifiedTo.status}
                message={error.WPS_QualifiedTo.message}
                value={headerObj.WPS_QualifiedTo}
                onChange={handleChange}
                setError={setError}
                error={error}
                allowlistfunction={isAllowCustomSpecialCharacters}
                allowcharacters="-"
                customMessage="Special Characters # & % + $ ' < > = ; not allowed"
              />
            </Row>
            <fieldset disabled={isReadonly}>
              <Row className="row-margin">
                <Col>
                  <div className="T-input w-100">
                    <input
                      type="text"
                      id="WPSH_CompanyName"
                      name="WPSH_CompanyName"
                      value={company_name[0].value}
                      readOnly
                      placeholder=" "
                    />
                    <Form.Label htmlFor="WPSH_CompanyName">
                      Company Name
                    </Form.Label>
                  </div>
                </Col>
                <SingleInput
                  divstyle="T-input w-100"
                  id="WPSH_SupportingPQR"
                  name="WPSH_SupportingPQR"
                  label="Supporting PQR"
                  maxLength={maxlength_WPS.WPSH_SupportingPQR}
                  status={error.WPSH_SupportingPQR.status}
                  message={error.WPSH_SupportingPQR.message}
                  value={headerObj.WPSH_SupportingPQR}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                />
                <SingleInput
                  md={6}
                  divstyle="T-input w-100"
                  id="WPSH_RefDoc"
                  name="WPSH_RefDoc"
                  label="Reference Docs"
                  maxLength={maxlength_WPS.WPSH_RefDoc}
                  status={error.WPSH_RefDoc.status}
                  message={error.WPSH_RefDoc.message}
                  value={headerObj.WPSH_RefDoc}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                />
              </Row>
              <Row className="mb-2 mt-2">
                <SingleInput
                  divstyle="T-input w-100"
                  id="WPSH_Scope"
                  name="WPSH_Scope"
                  label="Scopes"
                  maxLength={maxlength_WPS.WPSH_Scope}
                  status={error.WPSH_Scope.status}
                  message={error.WPSH_Scope.message}
                  value={headerObj.WPSH_Scope}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                />
              </Row>
              <Row className="mb-2 mt-2">
                <SingleInput
                  md={12}
                  divstyle="T-input w-100"
                  id="WPSH_JointDesc"
                  name="WPSH_JointDesc"
                  label="Joint Description"
                  maxLength={maxlength_WPS.WPSH_JointDesc}
                  status={error.WPSH_JointDesc.status}
                  message={error.WPSH_JointDesc.message}
                  value={headerObj.WPSH_JointDesc}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                />
              </Row>
            </fieldset>
          </Row>
          <fieldset disabled={isReadonly}>
            <Row className="md-2" style={{ padding: "20px 60px" }}>
              <span className="WPS-blue-text">Base Metals (QW-403)</span>
              <Row className="md-2">
                <SingleInput
                  md={3}
                  divstyle="green-input w-100"
                  id="WPSH_BM_Type_Type"
                  name="WPSH_BM_Type_Type"
                  label="Type"
                  maxLength={maxlength_WPS.WPSH_BM_Type_Type}
                  status={error.WPSH_BM_Type_Type.status}
                  message={error.WPSH_BM_Type_Type.message}
                  value={headerObj.WPSH_BM_Type_Type}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="+&=±-"
                  customMessage="Special Characters # % $ ' < > ; not allowed"
                />
                <Col md={3} className="mb-1">
                  <Form.Group className="green-input-select">
                    <div className="search-select">
                      <SearchSelect
                        required
                        data={PNoActive}
                        disabled={isReadonly}
                        stylegreen={
                          error.WPSH_BM_Type_PNo.status ? errorstyle : greenstyle
                        }
                        valueField={"wld_code"}
                        value={headerObj.WPSH_BM_Type_PNo}
                        labelField={"wld_code"}
                        placeholder=""
                        className={
                          error.WPSH_BM_Type_PNo.status ? "err-input" : ""
                        }
                        onChange={(pnoList) => {
                          setheaderObj((prev) => ({
                            ...prev,
                            WPSH_BM_Type_PNo: pnoList.value,
                          }));
                          setError((prevState) => ({
                            ...prevState,
                            WPSH_BM_Type_PNo: {},
                          }));
                        }}
                      ></SearchSelect>
                    </div>
                    <Form.Label className="Groove_green">P No.</Form.Label>
                  </Form.Group>
                  <div className="required-text-select">
                    {error.WPSH_BM_Type_PNo.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_BM_Type_PNo.message}
                      </Form.Text>
                    )}
                  </div>
                </Col>
                <SingleInput
                  md={3}
                  divstyle="T-input w-100"
                  id="WPSH_BM_Type_GNo"
                  name="WPSH_BM_Type_GNo"
                  label="G No."
                  maxLength={maxlength_WPS.WPSH_BM_Type_GNo}
                  status={error.WPSH_BM_Type_GNo.status}
                  message={error.WPSH_BM_Type_GNo.message}
                  value={headerObj.WPSH_BM_Type_GNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                />

                {isgroove ? (
                  <>
                    <SingleInput
                      md={3}
                      divstyle="T-input w-100"
                      disabled={isReadonly}
                      id="WPSH_BM_Type_HT_Con"
                      name="WPSH_BM_Type_HT_Con"
                      label="Base Metal HT Con"
                      maxLength={maxlength_WPS.WPSH_BM_Type_HT_Con}
                      status={error.WPSH_BM_Type_HT_Con.status}
                      message={error.WPSH_BM_Type_HT_Con.message}
                      value={headerObj.WPSH_BM_Type_HT_Con}
                      onChange={handleChange}
                      setError={setError}
                      error={error}
                      allowlistfunction={isAllowCustomSpecialCharacters}
                      allowcharacters="&-"
                      customMessage="Special Characters # % + $ ' < > = ; not allowed"
                    />
                  </>
                ) : (
                  ""
                )}
              </Row>
              <Row className="row-margin">
                <SingleInput
                  md={3}
                  divstyle="T-input w-100"
                  id="WPSH_BM_WeldingTo_Type"
                  name="WPSH_BM_WeldingTo_Type"
                  label="Welded To"
                  maxLength={maxlength_WPS.WPSH_BM_WeldingTo_Type}
                  status={error.WPSH_BM_WeldingTo_Type.status}
                  message={error.WPSH_BM_WeldingTo_Type.message}
                  value={headerObj.WPSH_BM_WeldingTo_Type}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="+&=±-"
                  customMessage="Special Characters # % $ ' < > ; not allowed"
                />
                <Col md={3}>
                  <Form.Group className="green-input-select">
                    <div className="search-select">
                      <SearchSelect
                        required
                        data={PNoActive}
                        disabled={isReadonly}
                        valueField={"wld_code"}
                        stylegreen={
                          error.WPSH_BM_WeldingTo_PNo.status
                            ? errorstyle
                            : greenstyle
                        }
                        value={headerObj.WPSH_BM_WeldingTo_PNo}
                        labelField={"wld_code"}
                        placeholder=""
                        className={
                          error.WPSH_BM_WeldingTo_PNo.status ? "err-input" : ""
                        }
                        onChange={(pnoList) => {
                          setheaderObj((prev) => ({
                            ...prev,
                            WPSH_BM_WeldingTo_PNo: pnoList.value,
                          }));
                          setError((prevState) => ({
                            ...prevState,
                            WPSH_BM_WeldingTo_PNo: {},
                          }));
                        }}
                      ></SearchSelect>
                    </div>
                    <Form.Label className="Groove_green">P No.</Form.Label>
                  </Form.Group>
                  <div className="required-text-select">
                    {error.WPSH_BM_WeldingTo_PNo.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_BM_WeldingTo_PNo.message}
                      </Form.Text>
                    )}
                  </div>
                </Col>

                <SingleInput
                  md={3}
                  divstyle="T-input w-100"
                  id="WPSH_BM_WeldingTo_GNo"
                  name="WPSH_BM_WeldingTo_GNo"
                  label="G No."
                  maxLength={maxlength_WPS.WPSH_BM_WeldingTo_GNo}
                  status={error.WPSH_BM_WeldingTo_GNo.status}
                  message={error.WPSH_BM_WeldingTo_GNo.message}
                  value={headerObj.WPSH_BM_WeldingTo_GNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                />

                {isgroove ? (
                  <>
                    <SingleInput
                      md={3}
                      divstyle="T-input w-100"
                      id="WPSH_BM_WeldingTo_HT_Con"
                      name="WPSH_BM_WeldingTo_HT_Con"
                      label="Base Metal HT Con"
                      maxLength={maxlength_WPS.WPSH_BM_WeldingTo_HT_Con}
                      status={error.WPSH_BM_WeldingTo_HT_Con.status}
                      message={error.WPSH_BM_WeldingTo_HT_Con.message}
                      value={headerObj.WPSH_BM_WeldingTo_HT_Con}
                      onChange={handleChange}
                      setError={setError}
                      error={error}
                      allowlistfunction={isAllowCustomSpecialCharacters}
                      allowcharacters="&-"
                      customMessage="Special Characters # % + $ ' < > = ; not allowed"
                    />
                  </>
                ) : (
                  ""
                )}
              </Row>
              <Row className={grooveclass}>
                <Col md={6}>
                  <General_Single_Input_select
                    name="WPSH_BM_Backing_Backing"
                    value={headerObj.WPSH_BM_Backing_Backing}
                    message={error.WPSH_BM_Backing_Backing.message}
                    status={error.WPSH_BM_Backing_Backing.status}
                    handleSelectChange={handleSelectChange}
                    disabled={isReadonly}
                    readOnly={isReadonly}
                    label="Backing"
                    array={Backing}
                  ></General_Single_Input_select>
                </Col>

                <SingleInput
                  md={3}
                  divstyle="T-input w-100"
                  id="WPSH_BM_Backing_PNo"
                  name="WPSH_BM_Backing_PNo"
                  label="P No."
                  maxLength={maxlength_WPS.WPSH_BM_Backing_PNo}
                  status={error.WPSH_BM_Backing_PNo.status}
                  message={error.WPSH_BM_Backing_PNo.message}
                  value={headerObj.WPSH_BM_Backing_PNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                />

                <SingleInput
                  md={3}
                  divstyle="T-input w-100"
                  id="WPSH_BM_Backing_GNo"
                  name="WPSH_BM_Backing_GNo"
                  label="G No."
                  maxLength={maxlength_WPS.WPSH_BM_Backing_GNo}
                  status={error.WPSH_BM_Backing_GNo.status}
                  message={error.WPSH_BM_Backing_GNo.message}
                  value={headerObj.WPSH_BM_Backing_GNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                />
              </Row>
              <Row className="mb-2 mt-2">
                <SingleInput
                  md={6}
                  divstyle="T-input w-100"
                  id="WPSH_BM_Backing_Material"
                  name="WPSH_BM_Backing_Material"
                  label="Backing Material"
                  maxLength={maxlength_WPS.WPSH_BM_Backing_Material}
                  status={error.WPSH_BM_Backing_Material.status}
                  message={error.WPSH_BM_Backing_Material.message}
                  value={headerObj.WPSH_BM_Backing_Material}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="-"
                  customMessage="Special Characters # & % + $ ' < > = ; not allowed"
                />

                {isgroove ? (
                  <>
                    <SingleInput
                      md={6}
                      divstyle="T-input w-100"
                      id="WPSH_BM_Retainer"
                      name="WPSH_BM_Retainer"
                      label="Retainer"
                      maxLength={maxlength_WPS.WPSH_BM_Retainer}
                      status={error.WPSH_BM_Retainer.status}
                      message={error.WPSH_BM_Retainer.message}
                      value={headerObj.WPSH_BM_Retainer}
                      onChange={handleChange}
                      setError={setError}
                      error={error}
                    />
                  </>
                ) : (
                  ""
                )}
              </Row>
              <Row>
                <SingleInput
                  divstyle="T-input w-100"
                  id="WPSH_BM_Notes"
                  name="WPSH_BM_Notes"
                  label="Notes"
                  maxLength={maxlength_WPS.WPSH_BM_Notes}
                  status={error.WPSH_BM_Notes.status}
                  message={error.WPSH_BM_Notes.message}
                  value={headerObj.WPSH_BM_Notes}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAllowCustomSpecialCharacters}
                  allowcharacters="+&=±-"
                  customMessage="Special Characters # % $ ' < > ; not allowed"
                />
              </Row>
            </Row>
            <Row style={{ padding: "20px 60px" }} className="WPS-Page-row-padding">
              <Row className="mb-1">
                <Col md={6}>
                  <div className="d-flex mb-2">
                    <p className="WPS-blue-text">Thickness Range Qualified</p>{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div>
                      <input
                        type="radio"
                        name="wld_TRQ_Type"
                        value="Welded"
                        checked={headerObj.wld_TRQ_Type === "Welded"}
                        onChange={(e) => handleChange(e)}
                      />
                      <span
                        className={
                          headerObj.wld_TRQ_Type === "Welded"
                            ? "fontWeight ms-2"
                            : "ms-2"
                        }
                      >
                        As-Welded
                      </span>
                    </div>
                    <div className="ms-5">
                      <input
                        type="radio"
                        name="wld_TRQ_Type"
                        value="PWHT"
                        onChange={(e) => handleChange(e)}
                        checked={headerObj.wld_TRQ_Type === "PWHT"}
                      />
                      <span
                        className={
                          headerObj.wld_TRQ_Type === "PWHT"
                            ? "fontWeight ms-2"
                            : "ms-2"
                        }
                      >
                        With PWHT
                      </span>
                    </div>
                  </div>
                </Col>
                <Col md={12}>
                  {isoverlay ? (
                    <WPS_Thickness_overlay
                      headerObj={headerObj}
                      error={error}
                      handleChange={handleChange}
                      setError={setError}
                    ></WPS_Thickness_overlay>
                  ) : (
                    <WPS_Thickness_Groove
                      headerObj={headerObj}
                      error={error}
                      handleChange={handleChange}
                      setError={setError}
                    ></WPS_Thickness_Groove>
                  )}
                </Col>
              </Row>
              {isoverlay ? (
                <Row className="mb-4">
                  <Col md={12}>
                    <SingleInput
                      name="WPSH_MinOvlFinThick"
                      type="text"
                      maxLength={maxlength_WPS.WPSH_MinOvlFinThick}
                      status={error.WPSH_MinOvlFinThick.status}
                      value={headerObj.WPSH_MinOvlFinThick}
                      onChange={handleChange}
                      label="Minimum Overlay Finished Thickness"
                      message={error.WPSH_MinOvlFinThick.message}
                      error={error}
                      setError={setError}
                    ></SingleInput>
                  </Col>
                </Row>
              ) : (
                ""
              )}
              <Row>
                <Col>
                  <p className="WPS-blue-text">Filler Metals (QW-404)</p>
                  <Table className="text-center">
                    <thead>
                      <tr className="border thead-color">
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title" colSpan={3}>
                          <span style={{ position: "relative", left: "15px" }}>
                            Thickness Range Qualified
                          </span>
                        </th>
                      </tr>
                      <tr className="border thead-color">
                        <th className="thickness_title"></th>
                        <th className="thickness_title Groove_green">Process</th>
                        <th className="thickness_title Groove_green">Type</th>
                        <th className={`${overclass} thickness_title`}>
                          Weld Layer(s)
                        </th>
                        <th className="thickness_title">SFA</th>
                        <th className="thickness_title">Classification</th>
                        <th className="thickness_title Groove_green">F. No.</th>
                        <th className="thickness_title">A. No.</th>
                        <th className="thickness_title">
                          Chemical Analysis or Trade Name
                        </th>
                        <th className="thickness_title">
                          {headerObj.wld_TRQ_Type === "PWHT"
                            ? "With PWHT Min."
                            : "As Welded Min."}
                        </th>
                        <th className="thickness_title">
                          {headerObj.wld_TRQ_Type === "PWHT"
                            ? "With PWHT Max."
                            : "As Welded Max."}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailObj &&
                        detailObj.map((item, i) => {
                          let detailerror = detailObj[i].error
                          return (
                            <tr
                              className={
                                detailObj[i]?.error
                                  ? "border WPSSelect error"
                                  : "border WPSSelect"
                              }
                            >
                              <td>
                                <Tooltip content={detailObj[i]?.errormessage}>
                                  <img
                                    src={Error}
                                    alt="Error"
                                    style={{
                                      display: detailerror
                                        ? "block"
                                        : "none",
                                    }}
                                  />
                                </Tooltip>
                              </td>
                              <td
                                style={{ width: "100px" }}
                                className="WPSSelectProcess"
                              >
                                <SearchSelect
                                  className="inspdrop green-input"
                                  data={ProcessActive}
                                  key={item?.id || `search-select-${i}`}
                                  valueField={"wld_code"}
                                  placeholder=""
                                  disabled={isReadonly}
                                  value={item.WPSD_Process}
                                  labelField={"wld_code"}
                                  onChange={(e) => {
                                    item.WPSD_Process = e.value;
                                    setIsEdited(true);
                                    if (e.value === "NA") {
                                      detailObj[i].WPSD_Process = "";
                                      detailObj[i].WPSD_ProcessCategory = "";
                                      detailObj[i].WPSD_WP_WeldingProcess = "";
                                      detailObj[i].WPSD_Type = "";
                                      detailObj[i].WPSD_FM_SFA = "";
                                      detailObj[i].WPSD_FM_FNo = "";
                                      detailObj[i].WPSD_FM_Ano = "";
                                      detailObj[i].WPSD_FM_Classification = "";
                                      detailObj[
                                        i
                                      ].WPSD_FM_ChemicalAnalysis_TradeName = "";
                                      detailObj[i].WPSD_FM_TRQ_Max = "";
                                      detailObj[i].WPSD_FM_TRQ_Min = "";
                                      detailObj[i].WPSH_WeldLayer = "";
                                      detailObj[
                                        i
                                      ].WPSD_Flux_Details_WI_CHECK = false;
                                    }
                                    setdetailObj((prevDetailObj) => {
                                      const updatedDetailObj = [...prevDetailObj];
                                      return updatedDetailObj;
                                    });
                                  }}
                                ></SearchSelect>
                              </td>
                              <td className="WPSSelectProcess">
                                <SearchSelect
                                  data={TypeData}
                                  valueField={"wld_type"}
                                  value={item.WPSD_Type}
                                  disabled={isReadonly}
                                  labelField={"wld_type"}
                                  placeholder=""
                                  onChange={(e) => {
                                    setIsEdited(true);
                                    item.WPSD_Type = e.value;
                                    setdetailObj([...detailObj]);
                                    detailObj[i].error = !(item.WPSD_Process !== "" || item.WPSD_Type !== "");
                                  }}
                                ></SearchSelect>
                              </td>

                              <td className={overclass}>
                                <SearchSelect
                                  data={WeldLayer}
                                  disabled={isReadonly}
                                  valueField={"value"}
                                  value={item.WPSH_WeldLayer}
                                  labelField={"name"}
                                  placeholder=""
                                  onChange={(e) => {
                                    item.WPSH_WeldLayer = e.value;
                                    setdetailObj([...detailObj]);
                                    detailObj[i].error = !(item.WPSD_Process !== "" || item.WPSH_WeldLayer !== "");
                                  }}
                                ></SearchSelect>
                              </td>

                              <td>
                                <SearchSelect
                                  className="inspdrop"
                                  data={SfaActive}
                                  disabled={isReadonly}
                                  valueField={"wld_code"}
                                  value={item.WPSD_FM_SFA}
                                  labelField={"wld_code"}
                                  placeholder=""
                                  onChange={(e) => {
                                    item.WPSD_FM_SFA = e.value;
                                    setdetailObj([...detailObj]);
                                    if (item.WPSD_Process !== "") {
                                      detailObj[i].error = item.WPSD_FM_SFA === "";
                                    } else {
                                      detailObj[i].error = false;
                                    }
                                  }}
                                ></SearchSelect>
                              </td>
                              <td className="WpsInput">
                                <input
                                  type="text"
                                  disabled={isReadonly}
                                  className={
                                    classError[i]?.status ? "error-input" : ""
                                  }
                                  maxLength={item.wld_WPSType === "Groove" ? 15 : 13}
                                  id="WPSD_FM_Classification"
                                  name="WPSD_FM_Classification"
                                  placeholder=" "
                                  value={item.WPSD_FM_Classification}
                                  onChange={(e) => handleChangedetailsarray(e, i)}
                                  onInput={(e) => {
                                    let tempError = [...classError];
                                    let error = isAllowCustomSpecialCharacters(
                                      e.target.value, "-", "Special Characters # & % + $ ' < > = ; not allowed"
                                    );
                                    tempError[i] = error;
                                    setClassError([...tempError]);
                                    setError((prevState) => ({
                                      ...prevState,
                                      WPSD_FM_Classification: classError,
                                    }));
                                  }}
                                />

                                <div
                                  style={{
                                    position: "relative",
                                    top: "6px",
                                    right: "25px",
                                  }}
                                  className={
                                    classError[i]?.status ? "d-block" : "d-none"
                                  }
                                >
                                  {error.WPSD_FM_Classification.status || (
                                    <Tooltip
                                      content={
                                        error.WPSD_FM_Classification.message ||
                                        classError[i]?.message
                                      }
                                    >
                                      <img
                                        src={Error}
                                        alt="Error"
                                        className="ms-1 imgplace"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              </td>
                              <td>
                                <SearchSelect
                                  className="inspdrop"
                                  data={FnoActive}
                                  disabled={isReadonly}
                                  valueField={"wld_code"}
                                  value={item.WPSD_FM_FNo}
                                  labelField={"wld_code"}
                                  placeholder=""
                                  onChange={(e) => {
                                    item.WPSD_FM_FNo = e.value;
                                    setdetailObj([...detailObj]);
                                    if (item.WPSD_Process !== "") {
                                      detailObj[i].error = item.WPSD_FM_FNo === "";
                                    } else {
                                      detailObj[i].error = false;
                                    }
                                  }}
                                ></SearchSelect>
                              </td>
                              <td>
                                <SearchSelect
                                  className="inspdrop"
                                  data={AnoActive}
                                  disabled={isReadonly}
                                  valueField={"wld_code"}
                                  value={item.WPSD_FM_Ano}
                                  labelField={"wld_code"}
                                  placeholder=""
                                  onChange={(e) => {
                                    item.WPSD_FM_Ano = e.value;
                                    setdetailObj([...detailObj]);
                                  }}
                                ></SearchSelect>
                              </td>
                              <td className="WpsInput">
                                <input
                                  type="text"
                                  className={
                                    chemicalAnaError[i]?.status
                                      ? "error-input"
                                      : ""
                                  }
                                  maxLength={item.wld_WPSType === "Groove" ? 32 : 28}
                                  id="WPSD_FM_ChemicalAnalysis_TradeName"
                                  name="WPSD_FM_ChemicalAnalysis_TradeName"
                                  placeholder=" "
                                  value={item.WPSD_FM_ChemicalAnalysis_TradeName}
                                  onChange={(e) => handleChangedetailsarray(e, i)}
                                  onInput={(e) => {
                                    let tempError = [...chemicalAnaError];
                                    let error = isAllowCustomSpecialCharacters(
                                      e.target.value, "&-", "Special Characters # % + $ ' < > = ; not allowed"
                                    );
                                    tempError[i] = error;
                                    setChemicalAnaError([...tempError]);
                                    setError((prevState) => ({
                                      ...prevState,
                                      WPSD_FM_ChemicalAnalysis_TradeName:
                                        chemicalAnaError,
                                    }));
                                  }}
                                />
                                <div
                                  style={{
                                    position: "relative",
                                    top: "6px",
                                    right: "25px",
                                  }}
                                  className={
                                    chemicalAnaError[i]?.status ? "d-block" : "d-none"
                                  }
                                >
                                  {error.WPSD_FM_ChemicalAnalysis_TradeName.status || (
                                    <Tooltip
                                      content={
                                        error.WPSD_FM_ChemicalAnalysis_TradeName.message ||
                                        chemicalAnaError[i]?.message
                                      }
                                    >
                                      <img
                                        src={Error}
                                        alt="Error"
                                        className="ms-1 imgplace"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              </td>

                              <td className="WpsInput">
                                <input
                                  type="text"
                                  style={{ position: "relative", width: "85px" }}
                                  className={
                                    FMMinError[i]?.status ? "error-input" : ""
                                  }
                                  name={"WPSD_FM_TRQ_Min"}
                                  maxLength={6}
                                  value={item.WPSD_FM_TRQ_Min}
                                  onChange={(e) => handleChangedetailsarray(e, i)}
                                  onInput={(e) => {
                                    let tempError = [...FMMinError];
                                    let error =
                                      isAlphanumericAllSpecialCharacters(
                                        e.target.value
                                      );
                                    tempError[i] = error;
                                    setFMMinError([...tempError]);
                                    setError((prevState) => ({
                                      ...prevState,
                                      WPSD_FM_TRQ_Min: FMMinError,
                                    }));
                                  }}
                                />
                                <div
                                  style={{
                                    position: "relative",
                                    top: "6px",
                                    right: "38px",
                                  }}
                                  className={
                                    FMMinError[i]?.status ? "d-block" : "d-none"
                                  }
                                >
                                  {error.WPSD_FM_TRQ_Min.status || (
                                    <Tooltip
                                      content={
                                        error.WPSD_FM_TRQ_Min.message ||
                                        FMMinError[i]?.message
                                      }
                                    >
                                      <img
                                        src={Error}
                                        alt="Error"
                                        className="ms-1 imgplace"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              </td>
                              <td className="WpsInput">
                                <input
                                  type="text"
                                  style={{ position: "relative", width: "85px" }}
                                  className={
                                    FMMaxError[i]?.status ? "error-input" : ""
                                  }
                                  name={"WPSD_FM_TRQ_Max"}
                                  maxLength={6}
                                  value={item.WPSD_FM_TRQ_Max}
                                  onChange={(e) => handleChangedetailsarray(e, i)}
                                  onInput={(e) => {
                                    let tempError = [...FMMaxError];
                                    let error =
                                      isAlphanumericAllSpecialCharacters(
                                        e.target.value
                                      );
                                    tempError[i] = error;
                                    setFMMaxError([...tempError]);
                                    setError((prevState) => ({
                                      ...prevState,
                                      WPSD_FM_TRQ_Max: FMMaxError,
                                    }));
                                  }}
                                />
                                <div
                                  style={{
                                    position: "relative",
                                    top: "6px",
                                    right: "38px",
                                  }}
                                  className={
                                    FMMaxError[i]?.status ? "d-block" : "d-none"
                                  }
                                >
                                  {error.WPSD_FM_TRQ_Max.status || (
                                    <Tooltip
                                      content={
                                        error.WPSD_FM_TRQ_Max.message ||
                                        FMMaxError[i]?.message
                                      }
                                    >
                                      <img
                                        src={Error}
                                        alt="Error"
                                        className="ms-1 imgplace"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              {/**
               * FLUX DETAILS IN WI SLIP LOGIC
               * 
               * PURPOSE:
               * Controls whether flux information appears in Welding Instruction (WI) slips
               * based on WPS flux radio button selection and process requirements.
               * 
               * BUSINESS LOGIC:
               * 
               * 1. FLUX RADIO BUTTON STATES (WPSH_fluxRadio):
               *    - "None": No flux required for process
               *    - "Required": Flux is mandatory for welding process
               *    - "Optional": Flux may be used based on conditions
               * 
               * 2. CHECKBOX ENABLING LOGIC:
               *    - Enabled: When process+type defined AND flux radio !≠ "None"
               *    - Disabled: When process incomplete OR flux radio = "None"
               *    - Formula: disableCheckbox = !(WPSD_Process && WPSD_Type) || WPSH_fluxRadio === "None"
               * 
               * 3. WI SLIP GENERATION IMPACT:
               *    - Checked: Flux details (SFA, Classification, F.No, A.No) included in WI slip
               *    - Unchecked: Flux information excluded from WI slip
               *    - Affects field welders' consumable selection and usage
               * 
               * 4. PROCESS-SPECIFIC BEHAVIOR:
               *    - SMAW (Stick): Flux coating integral to electrode (usually None)
               *    - SAW (Submerged Arc): External flux required (Required/Optional)
               *    - FCAW (Flux-Cored): Internal flux in wire (None/Optional)
               *    - GTAW/GMAW: No flux needed (None)
               * 
               * 5. LABEL GENERATION:
               *    - Format: "ProcessCode-ProcessType" (e.g., "SAW-Automatic")
               *    - Fallback: "Process N" where N is index + 1
               *    - Helps identify which process flux settings apply to
               * 
               * 6. DATA FLOW:
               *    WPS Creation → Flux Radio Selection → Process Definition → 
               *    Checkbox Enable/Disable → WI Generation → Field Usage
               * 
               * VALIDATION:
               * - Error displayed if flux details required but not properly configured
               * - Ensures WI slips contain accurate consumable information
               * - Prevents field welding with incorrect flux specifications
               */}
              <Row className="WPS-flux-checkbox-row">
                <Col md={2}>
                  <Form.Label className="WPS-flux-checkbox-text">
                    {" "}
                    Flux Details in WI Slip :
                  </Form.Label>
                </Col>
                {detailObj &&
                  detailObj.map((item, i) => {
                    // GENERATE PROCESS LABEL FOR IDENTIFICATION
                    let labelField =
                      item.WPSD_Process && item.WPSD_Type
                        ? item.WPSD_Process + "-" + item.WPSD_Type
                        : "Process " + (i + 1);
                    
                    // CHECKBOX ENABLING LOGIC
                    // Disabled when: Process incomplete OR flux not required
                    let disableCheckbox =
                      !(item.WPSD_Process && item.WPSD_Type) ||
                      headerObj.WPSH_fluxRadio === "None";
                    
                    return (
                      <>
                        <FluxDetailsCheckboxes
                          labelField={labelField}
                          nameField="WPSD_Flux_Details_WI_CHECK"
                          valueField={item.WPSD_Flux_Details_WI_CHECK}
                          disbaleCheckbox={disableCheckbox}
                          handleChange={(e) => {
                            let { checked } = e.target;
                            // UPDATE FLUX INCLUSION FLAG FOR WI SLIP GENERATION
                            item.WPSD_Flux_Details_WI_CHECK = checked;
                            setdetailObj([...detailObj]);
                          }}
                        />
                      </>
                    );
                  })}
                {error.WPSH_Flux_Details_WISLIP_CHECK.status && (
                  <Form.Text className="text-danger">
                    {error.WPSH_Flux_Details_WISLIP_CHECK.message}
                  </Form.Text>
                )}
              </Row>
              <Row className="mb-4">
                <Col>
                  <Table className="text-center">
                    <thead>
                      <tr className="border thead-color">
                        <th className="thickness_title"></th>
                        <th className="thickness_title">SFA</th>
                        <th className="thickness_title">Classification</th>
                        <th className="thickness_title">F. No.</th>
                        <th className="thickness_title">A. No.</th>
                        <th className="thickness_title">
                          Chemical Analysis or Trade Name
                        </th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                        <th className="thickness_title"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isoverlay && (
                        <WPSFillerMetalRow
                          title="Consumable Insert"
                          prefix="WPSH_ConsuInsert"
                          radioName="WPSH_consumRadio"
                          headerObj={headerObj}
                          setheaderObj={setheaderObj}
                          error={consumError}
                          setError={setConsumError}
                          handleChange={handleChange}
                          action={action}
                          message={message}
                        />
                      )}
                      <WPSFillerMetalRow
                        title="Flux"
                        prefix="WPSH_Flux"
                        radioName="WPSH_fluxRadio"
                        headerObj={headerObj}
                        setheaderObj={setheaderObj}
                        error={fluxError}
                        setError={setFluxError}
                        handleChange={handleChange}
                        action={action}

                        message={message}
                        detailObj={detailObj}
                        setdetailObj={setdetailObj}
                      />
                      <WPSFillerMetalRow
                        title="Sup Filler"
                        prefix="WPSH_SupFiller"
                        radioName="WPSH_filterRadio"
                        headerObj={headerObj}
                        setheaderObj={setheaderObj}
                        error={supfilterError}
                        setError={setSupFilterError}
                        handleChange={handleChange}
                        action={action}

                        message={message}
                      />
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col>
                  <General_Single_Input_select
                    name="WPSH_FM_FluxType"
                    value={headerObj.WPSH_FM_FluxType}
                    message={error.WPSH_FM_FluxType.message}
                    status={error.WPSH_FM_FluxType.status}
                    handleSelectChange={handleSelectChange}
                    disabled={isReadonly}
                    readOnly={isReadonly}
                    label="Flux Type"
                    array={Flux_type}
                  ></General_Single_Input_select>
                </Col>
                <Col>
                  <div className="T-input w-100">
                    <input
                      type="text"
                      id="WPSH_FM_FluxItemBatch"
                      name="WPSH_FM_FluxItemBatch"
                      disabled={isReadonly}
                      maxLength={30}
                      placeholder=" "
                      value={headerObj.WPSH_FM_FluxItemBatch}
                      onChange={handleChange}
                      onInput={(e) => {
                        let error = isAlphanumericAllSpecialCharacters(
                          e.target.value
                        );
                        setError((prevState) => ({
                          ...prevState,
                          WPSH_FM_FluxItemBatch: error,
                        }));
                      }}
                    />
                    <Form.Label htmlFor="WPSH_FM_FluxItemBatch">
                      Flux batch
                    </Form.Label>
                  </div>
                  <div className="required-text">
                    {error.WPSH_FM_FluxItemBatch.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_FM_FluxItemBatch.message}
                      </Form.Text>
                    )}
                  </div>
                </Col>

                <Col>
                  <div className="T-input w-100">
                    <select
                      id="WPSH_FM_FluxFromRecrush"
                      name="WPSH_FM_FluxFromRecrush"
                      isDisabled={isReadonly}
                      disabled={isReadonly}
                      placeholder=" "
                      value={headerObj.WPSH_FM_FluxFromRecrush}
                      className={
                        error.WPSH_FM_FluxFromRecrush.status ? "err-input" : ""
                      }
                      onChange={(e) => {
                        handleChange(e);
                        setError((prevState) => ({
                          ...prevState,
                          WPSH_FM_FluxFromRecrush: {},
                        }));
                      }}
                    >
                      {Flux_recrush.map((item) => {
                        return (
                          <option key={item.value} value={item.value}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                    <Form.Label htmlFor="WPSH_FM_FluxFromRecrush">
                      Flux from recrush
                    </Form.Label>
                  </div>
                  <div className="required-text">
                    {error.WPSH_FM_FluxFromRecrush.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_FM_FluxFromRecrush.message}
                      </Form.Text>
                    )}
                  </div>
                </Col>

                <Col>
                  <div className="T-input w-100">
                    <input
                      type="text"
                      id="WPSH_FM_FluxItemCode"
                      name="WPSH_FM_FluxItemCode"
                      disabled={isReadonly}
                      readOnly
                      className={
                        error.WPSH_FM_FluxItemCode.status ? "err-input" : ""
                      }
                      placeholder=" "
                      value={headerObj.WPSH_FM_FluxItemCode}
                    />
                    <Form.Label htmlFor="WPSH_FM_FluxItemCode">
                      Flux item code
                    </Form.Label>
                    {!isReadonly && headerObj.WPSH_Project_No && (
                      <BiSelectMultiple
                        size={20}
                        onClick={() => {
                          showPopUp(
                            "ItemActive",
                            "Single",
                            "wld_itemcode",
                            headerObj.WPSH_FM_FluxItemCode
                          );
                        }}
                        color={"gray"}
                        style={{
                          marginLeft: "14.5rem",
                          marginTop: "-3.7rem",
                        }}
                      />
                    )}
                  </div>
                  <div className="required-text">
                    {error.WPSH_FM_FluxItemCode.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_FM_FluxItemCode.message}
                      </Form.Text>
                    )}
                  </div>
                </Col>
              </Row>

              <Row className="mb-2">
                {isoverlay ? (
                  ""
                ) : (
                  <Col>
                    <General_Single_Input_select
                      name="WPSH_FM_AlloyFlux"
                      value={headerObj.WPSH_FM_AlloyFlux}
                      message={error.WPSH_FM_AlloyFlux.message}
                      status={error.WPSH_FM_AlloyFlux.status}
                      handleSelectChange={handleSelectChange}
                      label="Alloy Flux"
                      disabled={isReadonly}
                      array={Alloy_flux}
                    ></General_Single_Input_select>
                  </Col>
                )}
                <Col md={3}>
                  <General_Single_Input_select
                    name="WPSH_FM_AlloyElement"
                    value={headerObj.WPSH_FM_AlloyElement}
                    message={error.WPSH_FM_AlloyElement.message}
                    status={error.WPSH_FM_AlloyElement.status}
                    handleSelectChange={handleSelectChange}
                    label="Alloy Element"
                    disabled={isReadonly}
                    array={Alloy_element}
                  ></General_Single_Input_select>
                </Col>
                {isoverlay ? (
                  ""
                ) : (
                  <Col>
                    <General_Single_Input_select
                      name="WPSH_FM_Add_Del_Filler"
                      value={headerObj.WPSH_FM_Add_Del_Filler}
                      message={error.WPSH_FM_Add_Del_Filler.message}
                      status={error.WPSH_FM_Add_Del_Filler.status}
                      handleSelectChange={handleSelectChange}
                      label="Addition/Deletion of Filler"
                      disabled={isReadonly}
                      array={Addition_deletion_filler}
                    ></General_Single_Input_select>
                  </Col>
                )}
                {isgroove ? (
                  <Col>
                    <General_Single_Input_select
                      name="WPSH_FM_Add_Del_Flux"
                      value={headerObj.WPSH_FM_Add_Del_Flux}
                      message={error.WPSH_FM_Add_Del_Flux.message}
                      status={error.WPSH_FM_Add_Del_Flux.status}
                      handleSelectChange={handleSelectChange}
                      label="Addition/Deletion of Flux(GTAW)"
                      disabled={isReadonly}
                      array={Addition_deletion_flux}
                    ></General_Single_Input_select>
                  </Col>
                ) : (
                  ""
                )}

                {isoverlay ? (
                  <Col md={6}>
                    <General_Single_Input_select
                      name="WPSH_FM_Add_Del_orchange"
                      value={headerObj.WPSH_FM_Add_Del_orchange}
                      message={error.WPSH_FM_Add_Del_orchange.message}
                      status={error.WPSH_FM_Add_Del_orchange.status}
                      handleSelectChange={handleSelectChange}
                      label="Addition/Deletion or Changes > 10% in suppl. filler metal"
                      disabled={isReadonly}
                      array={Addition_deletion_changes}
                    ></General_Single_Input_select>
                  </Col>
                ) : (
                  ""
                )}

                {isoverlay ? (
                  <Col md={3}>
                    <div className="T-input w-100">
                      <input
                        type="text"
                        id="WPSH_FM_NominalFlux"
                        name="WPSH_FM_NominalFlux"
                        maxLength={30}
                        placeholder=" "
                        value={headerObj?.WPSH_FM_NominalFlux}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericAllSpecialCharacters(
                            e.target.value
                          );
                          setError((prevState) => ({
                            ...prevState,
                            WPSH_FM_NominalFlux: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="WPSH_FM_NominalFlux">
                        Nominal Flux Comp.
                      </Form.Label>
                    </div>
                    <div className="required-text">
                      {error.WPSH_FM_NominalFlux.status && (
                        <Form.Text className="text-danger">
                          {error.WPSH_FM_NominalFlux.message}
                        </Form.Text>
                      )}
                    </div>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
              <Row className="mb-2">
                <Col md={6}>
                  <div className="T-input w-100">
                    <input
                      type="text"
                      id="WPSH_FM_FilerMetal"
                      name="WPSH_FM_FilerMetal"
                      maxLength={headerObj.wld_WPSType === "Groove" ? 25 : 23}
                      placeholder=" "
                      value={headerObj?.WPSH_FM_FilerMetal}
                      onChange={handleChange}
                      onInput={(e) => {
                        let error = isAlphanumericAllSpecialCharacters(
                          e.target.value
                        );
                        setError((prevState) => ({
                          ...prevState,
                          WPSH_FM_FilerMetal: error,
                        }));
                      }}
                    />
                    <Form.Label htmlFor="WPSH_FM_FilerMetal">
                      Filler metal others
                    </Form.Label>
                  </div>
                  <div className="required-text">
                    {error.WPSH_FM_FilerMetal.status && (
                      <Form.Text className="text-danger">
                        {error.WPSH_FM_FilerMetal.message}
                      </Form.Text>
                    )}
                  </div>
                </Col>
              </Row>
            </Row>
          </fieldset>
        </Row>
        <RenderIf isTrue={popUp.type === "Single" && showForm}>
          <SingleValuePopUp
            show={showForm}
            onHide={() => setShowForm(false)}
            setSelected={setPopUpData}
            masterName={popUp.name}
            paramkey={popUp.key}
            paramvalue={popUp.value}
            data={ItemActive}
            backdrop="static"
            title="Flux Item Code"
          />
        </RenderIf>
      </>
    );
  }
);

export default General;
